<template>
  <div class="ongkir">
    <div class="flex mdmax:flex-col items-start gap-6">
      <div class="bg-white p-6 w-4/12 mdmax:w-full shadow-md">
        <p class="text-lg font-bold mb-6">{{ $t('ongkir.title') }}</p>
        <div class="mb-6 text-left relative">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('ongkir.origin') }}</label>
          <div class="relative">
            <TextField withIcon type="text" @input="searchCity($event, 'origin')" v-model="originSearch" :placeholder="$t('ongkir.originPlaceholder')" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
            <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching['origin']" />
            <transition name="fade" mode="out-in">
              <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion['origin']">
                <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                  <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300 " v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city, 'origin')">
                    {{ city.village }}, {{ city.area_display }}
                  </li>
                </ul>
                <div class="py-4 text-center" v-else>
                  {{ $t('ongkir.dataNotFound') }}
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="mb-6 text-left relative">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('ongkir.destination') }}</label>
          <div class="relative">
            <TextField withIcon type="text" @input="searchCity($event, 'destination')" v-model="destinationSearch" :placeholder="$t('ongkir.destinationPlaceholder')" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
            <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching['destination']" />
            <transition name="fade" mode="out-in">
              <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion['destination']">
                <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                  <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300 " v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city, 'destination')">
                    {{ city.village }}, {{ city.area_display }}
                  </li>
                </ul>
                <div class="py-4 text-center" v-else>
                  {{ $t('ongkir.dataNotFound') }}
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('ongkir.weight') }}</label>
          <div class="relative">
            <TextField type="number" withIcon :placeholder="$t('ongkir.weightPlaceholder')" v-model="payloads.package_weight" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Box />
            </div>
            <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
              Kg
            </div>
          </div>
        </div>
        <div class="mb-10">
          <label class="text-sm text-neutral-700 font-medium mb-4 inline-block">{{ $t('ongkir.logistic') }}</label>
          <div class="grid-layout">
            <!-- Select All Checkbox -->
            <div class="mb-2 col-span-2 flex items-center">
              <input
                type="checkbox"
                class="styled-checkbox"
                id="select-all-logistics"
                :checked="selectedLogistics.length === logisticProvider.length"
                @change="selectedLogistics = $event.target.checked ? logisticProvider.map(l => l.id) : []"
              />
              <label for="select-all-logistics" class="text-sm font-semibold">{{ $t('ongkir.allLogistic') }}</label>
            </div>
            <div class="" v-for="(logistic, index) in logisticProvider" :key="'logistic-' + index">
              <input type="checkbox" class="styled-checkbox" name="logistics" :id="logistic.id" :value="logistic.id" v-model="selectedLogistics" />
              <label :for="logistic.id" class="text-sm">{{ logistic.name }}</label>
              
            </div>
          </div>
        </div>
        <div class="flex justify-end items-center">
          <Button :buttonText="$t('ongkir.submit')" type="primary" :disabled="isDisabled" @action="cekOngkir()" />
        </div>
      </div>
      <div class="w-8/12 mdmax:w-full ongkir-list flex items-stretch shadow-md">
        <template v-if="ongkirList.length < 1">
          <div class="flex-1 flex justify-center flex-col items-center bg-white py-12 px-6">
            <div class="flex justify-center items-center flex-col h-full text-center">
              <p class="font-bold mb-1">{{ $t('ongkir.invalidTitle') }}</p>
              <p class="text-sm text-neutral-500">{{ $t('ongkir.invalidDesc') }}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="w-full">
            <div class="py-3 px-6 flex mdmax:flex-col justify-between mdmax:justify-start gap-9 mdmax:gap-4 items-center mdmax:items-start bg-white shadow-border-b mdmax:px-4">
              <div class="flex items-center gap-6">
                <Box2 color="primary-500" />
                <div class="flex flex-col">
                  <p class="text-xs">{{ $t('ongkir.show') }} {{ totalServiceCount }} {{ $t('ongkir.service') }}</p>
                  <p class="font-bold">{{ originInformation.district }} - {{ destinationInformation.district }}</p>
                </div>
              </div>
              <div class="flex gap-2 items-center">
                <img src="@/assets/images/Custom.svg" />
                <p class="text-xs text-white bg-primary-500 rounded-md px-2 py-1">{{ payloads.package_weight }} kg</p>
              </div>
            </div>
            <div class="px-6 mdmax:px-4 pt-6 pb-6">
              <div class="border border-gray-200 bg-white rounded-xl shadow-sm mb-4 overflow-hidden" v-for="(value, key, index) in deliveryServiceByGroup" :key="index">
                <input type="checkbox" :id="key" :checked="value.isVisible" class="hidden" />
                <label :for="key" class="flex justify-between items-center p-4 cursor-pointer hover:bg-neutral-50 transition-colors" @click="expand(key, value.isVisible)" :class="{'border-b border-gray-200': value.isVisible}">
                  <p class="text-base font-bold text-neutral-800">{{ key }}</p>
                  <span :class="{ 'transform rotate-180': value.isVisible }" class="transition-transform duration-300 text-neutral-500">
                    <Chevron direction="down" />
                  </span>
                </label>
                <div class="sub bg-neutral-50" :class="{ open: value.isVisible }">
                  <div class="p-4">
                    <div v-for="(service, idx) in value.package" :key="'service' + idx" 
                         @click="selectService(service)"
                         class="shadow-sm px-4 py-3 rounded-lg mb-3 last:mb-0 flex justify-between items-center transition-all duration-200 border cursor-pointer"
                       :class="{'bg-secondary-100 opacity-60 cursor-not-allowed border-neutral-200': parseInt(service.package.final_cost) <= 0 || parseInt(payloads.package_weight) < parseInt(service.package.minimum_weight) || parseInt(payloads.package_weight) > parseInt(service.package.maximum_weight), 'bg-white border-transparent hover:border-secondary-300': parseInt(service.package.final_cost) > 0 && parseInt(payloads.package_weight) >= parseInt(service.package.minimum_weight) && parseInt(payloads.package_weight) <= parseInt(service.package.maximum_weight)}">
                    <div class="flex gap-4 items-center">
                      <div class="w-16 flex items-center justify-center">
                        <img :src="service.logo" :alt="service.name" v-if="service.logo" class="max-h-8 object-contain" />
                        <LogisticPlaceholder :logisticName="service.name" v-else />
                      </div>
                      <div class="flex flex-col gap-1">
                        <p class="font-medium text-xs">{{ service.name }}</p>
                        <p class="text-sm font-semibold text-neutral-800">{{ service.package.name }}</p>
                        <template v-if="parseInt(payloads.package_weight) < parseInt(service.package.minimum_weight)">
                          <p class="text-xs text-red-500 mt-0.5">Minimal berat pengiriman {{ service.name }} {{ service.package.minimum_weight }} Kg</p>
                        </template>
                        <template v-else-if="parseInt(payloads.package_weight) > parseInt(service.package.maximum_weight)">
                          <p class="text-xs text-red-500 mt-0.5">Maksimal berat pengiriman {{ service.name }} {{ service.package.maximum_weight }} Kg</p>
                        </template>
                        <template v-else-if="parseInt(service.package.final_cost) <= 0">
                          <p class="text-xs text-red-500 mt-0.5">Layanan saat ini tidak tersedia</p>
                        </template>
                      </div>
                    </div>
                    <div class="flex flex-col gap-1 text-right items-end" v-if="parseInt(service.package.final_cost) > 0 && parseInt(payloads.package_weight) >= parseInt(service.package.minimum_weight) && parseInt(payloads.package_weight) <= parseInt(service.package.maximum_weight)">
                      <p class="flex items-center gap-2">
                        <Time width="12" height="12" /> <span class="text-xs text-secondary-600 font-medium">{{ service.package.est_delivery_time_range_min }} - {{ service.package.est_delivery_time_range_max }}</span>
                      </p>
                      <p class="text-xs text-neutral-400 line-through" v-if="service.package.final_cost !== service.package.shipment_cost">{{ service.package.shipment_cost | currencyFormat }}</p>
                      <p class="text-base font-bold text-primary-600">
                        {{ service.package.final_cost | currencyFormat }}
                      </p>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    
    <Modal :modalVisible="showConfirmationModal" @close="showConfirmationModal = false" id="confirmation-modal" width="400px">
      <template slot="modal-content">
        <div class="flex flex-col items-center text-center py-4">
          <p class="font-bold text-xl text-neutral-800 mb-3">Konfirmasi Pengiriman</p>
          <p class="text-sm text-neutral-600 mb-8 px-2">Lanjutkan pengiriman paket ? Anda akan dialihkan ke halaman Kirim Paket untuk melengkapi data dan menyelesaikan proses pengiriman.</p>
          <div class="flex gap-4 w-full">
            <Button buttonText="Batal" type="secondary" class="flex-1" @action="showConfirmationModal = false" />
            <Button buttonText="Lanjutkan" type="primary" class="flex-1" @action="proceedToCreateOrder" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { currencyFormat, formatDate } from '@/util'
export default {
  filters: {
    currencyFormat,
    formatDate
  },
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Box2: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Box2'),
    Box: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Box'),
    Time: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Time'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    LogisticPlaceholder: () => import(/* webpackChunkName: "LogisticPlaceholder" */ '@/components/Icons/LogisticPlaceholder'),
    Search: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Search'),
    Chevron: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Chevron'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data() {
    return {
      showConfirmationModal: false,
      selectedService: null,
      deliveryServiceByGroup: {},
      selectedLogistics: [],
      payloads: {
        origin_city: null,
        destination_city: null,
        package_weight: null,
        service_ids: []
      },
      debounce: null,
      origin: '',
      originSearch: '',
      originInformation: '',
      destination: '',
      destinationSearch: '',
      destinationInformation: '',
      cityKeyword: null,
      visibleSuggestion: {
        origin: false,
        destination: false
      },
      isSearching: {
        origin: false,
        destination: false
      }
    }
  },
  computed: {
    ...mapGetters('master', ['cities']),
    ...mapGetters('common', ['logisticProvider', 'ongkirList']),
    isDisabled() {
      return !this.payloads.origin_city || !this.payloads.destination_city || !this.payloads.package_weight || this.selectedLogistics.length === 0
    },
    totalServiceCount() {
      let count = 0
      this.ongkirList.forEach(item => {
        count += item.packages.length
      })
      return count
    }
  },
  watch: {
    ongkirList: {
      handler(newList) {
        const arrGroup = []
        newList.forEach(item => {
          item.packages.forEach(elem => {
            const constructedObject = {
              logo: item.logo,
              name: item.name,
              package: elem,
              logistic_id: item.id
            }
            arrGroup.push(constructedObject)
          })
        })
        const grouped = arrGroup.reduce((r, a) => {
          const groupDelivery = a.package.group_delivery || 'Lainnya'
          r[groupDelivery] = r[groupDelivery] || []
          r[groupDelivery].push(a)
          return r
        }, Object.create(null))
        
        const sortedKeys = Object.keys(grouped).sort((a, b) => {
          const orderMap = {
            'regular': 1, 'regulare': 1, 'reguler': 1,
            'nextday': 2,
            'sameday': 3,
            'cargo': 4
          };
          const aLower = a.toLowerCase();
          const bLower = b.toLowerCase();
          const aIndex = orderMap[aLower] || 99;
          const bIndex = orderMap[bLower] || 99;
          
          if (aIndex !== bIndex) return aIndex - bIndex;
          return a.localeCompare(b);
        });
        
        const result = {}
        let isFirstOpened = false;
        sortedKeys.forEach(key => {
          const isRegular = key.toLowerCase() === 'regular' || key.toLowerCase() === 'reguler' || key.toLowerCase() === 'regulare';
          let isVisible = false;
          if (isRegular && !isFirstOpened) {
            isVisible = true;
            isFirstOpened = true;
          }
          result[key] = {
            isVisible,
            package: grouped[key]
          }
        })
        
        if (!isFirstOpened && sortedKeys.length > 0) {
          result[sortedKeys[0]].isVisible = true;
        }
        this.deliveryServiceByGroup = result
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getLogisticProviderList()
  },
  methods: {
    ...mapActions('master', ['getCities']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'ongkir', 'getLogisticProvider']),
    cekOngkir() {
      const constructedPayload = {
        page: 1,
        per_page: 100,
        search_keyword: '',
        sort: 'ASC',
        origin_city: this.payloads.origin_city,
        destination_city: this.payloads.destination_city,
        service_ids: this.selectedLogistics.join(','),
        package_weight: this.payloads.package_weight,
        is_require_pod: false
      }
      this.showLoading()
      this.ongkir({
        params: constructedPayload
      }).then(() => {
        this.hideLoading()
      })
    },
    getLogisticProviderList() {
      this.getLogisticProvider({
        params: {
          search_keyword: '',
          sort: 'ASC'
        }
      })
    },
    searchCity(value, target) {
      this.cityKeyword = null
      if (value) this.isSearching[target] = true
      this.visibleSuggestion[target] = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.cityKeyword = value
          this.getCities({
            params: {
              page: 1,
              per_page: 1000,
              search_keyword: this.cityKeyword
            }
          }).then(() => {
            this.visibleSuggestion[target] = true
            this.isSearching[target] = false
          })
        }
      }, 800)
    },
    selectCity(data, target) {
      if (target === 'origin') {
        this.originInformation = data
        this.payloads.origin_city = data.code
        this.originSearch = `${data.village}, ${data.area_display}`
      } else {
        this.destinationInformation = data
        this.payloads.destination_city = data.code
        this.destinationSearch = `${data.village}, ${data.area_display}`
      }
      this.visibleSuggestion[target] = false
    },
    selectService(service) {
      if (parseInt(service.package.final_cost) > 0 && parseInt(this.payloads.package_weight) >= parseInt(service.package.minimum_weight) && parseInt(this.payloads.package_weight) <= parseInt(service.package.maximum_weight)) {
        this.selectedService = service
        this.showConfirmationModal = true
      }
    },
    proceedToCreateOrder() {
      const orderData = {
        service: this.selectedService,
        originInformation: this.originInformation,
        destinationInformation: this.destinationInformation,
        originSearch: this.originSearch,
        destinationSearch: this.destinationSearch,
        package_weight: this.payloads.package_weight
      }
      sessionStorage.setItem('ongkirOrderData', JSON.stringify(orderData))
      this.showConfirmationModal = false
      this.$router.push('/ongkir/create')
    },
    expand(key, visible) {
      this.deliveryServiceByGroup[key].isVisible = !visible
      Object.entries(this.deliveryServiceByGroup).forEach(([item]) => {
        if (item !== key) this.deliveryServiceByGroup[item].isVisible = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
    display: flex;
  }

  // Box.
  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 2px solid #101840;
    border-radius: 4px;
    outline: none;
  }

  // Box hover
  &:hover + label:before {
    background: #101840;
  }

  // Box focus
  &:focus + label:before {
    // box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
  }

  // Box checked
  &:checked + label:before {
    background: #fff;
  }

  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: #101840;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 #101840, 4px 0 0 #101840, 4px -2px 0 #101840, 4px -4px 0 #101840, 4px -6px 0 #101840, 4px -8px 0 #101840;
    transform: rotate(45deg);
  }
}
.grid-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 12px;
  column-gap: 24px;
  .ratio {
    aspect-ratio: 1/1;
  }
}
.ongkir-list {
  min-height: calc(100vh - 220px);
  @media screen and (max-width: 767px) {
    min-height: auto;
  }
}
.max-width-logo {
  max-width: 120px;
}
.logo {
  width: 120px;
  height: 40px;
  background-image: var(--url);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.sub {
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  &.open {
    height: auto;
  }
}
</style>
